import { ShowIcon } from "../../assets/icons/iconsProvider";
import {
  EMPTY_STRING,
  globalConstants,
  SET_BY_TRADE_IN_MARGIN_OPTIONS,
  STORE_BILLING_STATUS,
  routesPathConstants,
  BG_JOB_STATUS,
} from "../../constants";
import { ProgressBar, TableCustomCellWrapper } from "../components";
import TableCustomAppliesToField from "../components/table/TableCustomAppliesToField";
import { editDeleteActions } from "./genericUtility";

import {
  calculateBarWidth,
  createCompanyDynamicUrl,
  formatDate,
  getColumnStatusColumn,
} from "../utility";
import { isAdminLogin } from "./authenticationUtility";

const isStoreActive = (store, user, storeFetchingResponse = false) => {
  let response = false;
  const isAdmin = user && isAdminLogin(user);

  // initial state of store is undefined on reload so in case of routes we want to return true (so it stays on the same URL) and in case of dashboard we want to return EMPTY_STRING so it does not show store deactive text
  if (!store || store?.isStoreActive === undefined) {
    response = storeFetchingResponse;
  }
  // Admin user will have access to the store no matter what so no need to check payment status etc
  else if (isAdmin) {
    response = true;
  }
  // Payment is due or trial ended: disable access because of payment
  else if (
    store.billing?.storeBillingStatus === STORE_BILLING_STATUS.SERVICE_SUSPENDED
  ) {
    response = false;
  }
  // Admin user or store is active
  else if (store.isStoreActive) {
    response = true;
  }
  // Store is set to inactive by admin using store edit store.isStoreActive === false
  else {
  }

  return response;
};
const isStripeSubscriptionActive = (billing) => {
  const storeBilling = billing?.billing || billing || {};
  return (
    storeBilling.storeBillingStatus === STORE_BILLING_STATUS.ACTIVE_SUBSCRIPTION
  );
};

const getAllStoreIds = (companyStores = []) => {
  return companyStores?.map((store) => store.id).join(",") || EMPTY_STRING;
};

const createCompanyStoreOptions = (
  companyStores,
  showAllStoresOption = true
) => {
  const storeOptions = companyStores.map((store) => ({
    label: store.storeName,
    value: store.id,
  }));
  return [
    showAllStoresOption &&
      companyStores.length > 1 && {
        label: globalConstants.ALL_STORES,
        value: getAllStoreIds(companyStores),
      },
    ...storeOptions,
  ].filter(Boolean);
};

const getCustomTaxRulesColumn = (props) => {
  const { handleEditClick, handleDeleteClick } = props;
  return [
    {
      id: "setBy",
      name: "Set By",
      selector: (row) => row.taxType,
      cell: (row) => {
        return (
          <TableCustomCellWrapper
            cellValue={
              SET_BY_TRADE_IN_MARGIN_OPTIONS.find(
                (item) => item.value === row.taxType
              ).label
            }
          />
        );
      },
      sortable: true,
      sortDirection: null,
    },
    {
      id: "appliesTo",
      name: "Applies To",
      selector: (row) => row.taxGroup,
      cell: (row) => {
        return (
          <TableCustomAppliesToField
            row={row}
            groupArray={row.taxGroup}
            groupType={row.taxType}
          />
        );
      },
      sortable: true,
      sortDirection: null,
    },
    {
      id: "saleTaxRate",
      name: "Sale Tax Rate",
      selector: (row) => row.saleTaxRate,
      cell: (row) => (
        <TableCustomCellWrapper cellValue={`${row.saleTaxRate}%`} />
      ),
      sortable: true,
      sortDirection: null,
    },
    editDeleteActions(handleEditClick, handleDeleteClick),
  ];
};

const getResetInventoryColumns = (props) => {
  const { handleViewStatus } = props;
  return [
    {
      id: "startedAt",
      name: "Started at",
      selector: (row) => row.miscData?.startedAt,
      cell: (row) => (
        <span>
          {row?.miscData?.startedAt
            ? formatDate(row.miscData.startedAt)
            : "N/A"}
        </span>
      ),
      sortable: false,
      sortDirection: null,
    },
    {
      id: "completedAt",
      name: "Completed at",
      selector: (row) => row.miscData?.completedAt,
      cell: (row) => (
        <span>
          {row?.miscData?.completedAt
            ? formatDate(row.miscData.completedAt)
            : "-"}
        </span>
      ),
      sortable: false,
      sortDirection: null,
    },
    {
      id: "resumeTime",
      name: "Resume Time",
      selector: (row) => row.miscData?.resumeTime,
      cell: (row) => (
        <span>
          {row?.miscData?.resumeTime &&
          row?.miscData?.status === BG_JOB_STATUS.PAUSED
            ? formatDate(row.miscData.resumeTime)
            : "-"}
        </span>
      ),
      sortable: false,
      sortDirection: null,
    },
    getColumnStatusColumn((row) => row.miscData.status),
    {
      id: "progressPercentage",
      name: "Progress",
      selector: (row) => row?.miscData?.progressPercentage || 0,
      cell: (row) => {
        const progress = row?.miscData?.progressPercentage || 0;
        return (
          <div style={{ width: "100%" }}>
            <ProgressBar
              min={0}
              max={100}
              current={progress}
              percentage={calculateBarWidth(100, progress)}
              label={`${progress}%`}
              barWrapper={true}
            />
          </div>
        );
      },
      sortable: false,
      sortDirection: null,
    },
    {
      id: "action",
      name: "Action",
      cell: (row) => (
        <button
          type="button"
          onClick={() => handleViewStatus(row)}
          className="action-Button-Wrapper view-order-icon"
        >
          <ShowIcon className="cursor-pointer" />
        </button>
      ),
      button: true,
    },
  ];
};
const handleEditStoreClick = (row, navigate) => {
  navigate(createCompanyDynamicUrl(routesPathConstants.ADMIN_STORES_EDIT), {
    state: { ...row },
  });
};

export {
  isStoreActive,
  handleEditStoreClick,
  isStripeSubscriptionActive,
  createCompanyStoreOptions,
  getAllStoreIds,
  getCustomTaxRulesColumn,
  getResetInventoryColumns,
};
